// Module
var code = "<div class=\"circle-done\"> <div class=\"circle-content\"><i class=\"fas fa-check circle-checked\"></i></div> </div>";
// Exports
module.exports = code;